<main
  class="flex min-h-screen items-center justify-center bg-[radial-gradient(circle_at_top,_rgba(37,99,235,0.16),_transparent_34%),linear-gradient(180deg,_#f8fafc_0%,_#e2e8f0_100%)] p-6"
>
  <button
    type="button"
    class="min-w-[240px] rounded-full border-0 bg-slate-900 px-7 py-4 text-base font-semibold tracking-[0.01em] text-white shadow-[0_16px_40px_rgba(15,23,42,0.24)] transition duration-150 ease-in-out hover:-translate-y-px hover:bg-slate-950 hover:shadow-[0_20px_48px_rgba(15,23,42,0.28)] focus-visible:outline focus-visible:outline-3 focus-visible:outline-offset-4 focus-visible:outline-blue-500/35 active:translate-y-0"
    (click)="toggleLoginMode()"
  >
    {{ buttonLabel() }}
  </button>
</main>
